import React, { useState } from 'react';
import { Check, Link2 } from 'lucide-react';
import { PUBLIC_SITE_URL } from '../../data/site';
type CopyLinkButtonProps = {
  hash?: string;
  label?: string;
  iconOnly?: boolean; /** Ruta legible concreta (p. ej. la de un evento dentro de una lista). */
  path?: string;
};

/** Enlace público: dominio de PUBLIC_SITE_URL (si está definido) + ruta legible. */
export function publicUrl(pathAndQuery: string) {
  const origin = PUBLIC_SITE_URL.replace(/\/+$/, '') || window.location.origin;
  return `${origin}${pathAndQuery.startsWith('/') ? '' : '/'}${pathAndQuery}`;
}
export function CopyLinkButton({
  hash,
  label = 'Copiar enlace',
  iconOnly = false,
  path
}: CopyLinkButtonProps) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    const url = path ? publicUrl(path) : publicUrl(`${window.location.pathname}${window.location.search}${hash ? `#${hash}` : ''}`);
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
  };
  const Icon = copied ? Check : Link2;
  const text = copied ? 'Enlace copiado' : label;
  if (iconOnly) {
    return <button type="button" onClick={copy} aria-label={text} title={text} className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ${copied ? 'text-[#D4AF37]' : 'text-gray-500 hover:bg-white/5 hover:text-white'}`} data-id="element-323" data-mp="3xf9usl2subq">
        <Icon className="h-4 w-4" data-id="element-324" data-mp="mq9fgvwt7a3a" />
      </button>;
  }
  return <button type="button" onClick={copy} className="inline-flex h-10 items-center gap-2 rounded-full border border-white/15 px-4 text-sm font-semibold text-gray-200 whitespace-nowrap transition-colors duration-150 hover:border-[#D4AF37]/50 hover:text-white" data-id="element-325" data-mp="mogb5n9o51yg">
      <Icon className={`h-4 w-4 ${copied ? 'text-[#D4AF37]' : ''}`} aria-hidden="true" data-id="element-326" data-mp="1dx8bkhyeaiup" />
      <span aria-live="polite" data-id="element-327" data-mp="18zzrgbtos4qt">{text}</span>
    </button>;
}